import { styled, TextField } from '@mui/material';
export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    color: theme.palette.text.primary,
    '& fieldset': {
      borderColor: theme.palette.dark['dark_3.05'],
    },
    '&:hover fieldset': {
      borderColor: theme.palette.dark.dark_4,
    },
  },
}));
